<div class="layout-col full bg-background">
  <mat-toolbar elderTheme>
    <div class="flex layout-row place-end-center gap-sm">
      <button mat-icon-button matDialogClose="">
        <mat-icon>close</mat-icon>
      </button>
      <span>{{ 'facilities.facility' | translate }}: {{ ctx.facility.name }}</span>
      <span class="flex"></span>
      @switch (ctx.viewMode) {
        @case (ViewMode.PREVIEW) {
          <span>{{ ctx.interval | isoInterval }}</span>
        }
        @case (ViewMode.LIVE) {
          <span>{{ ctx.liveTimestamp.toString() | date: 'medium' }}</span>
        }
      }
      <span class="flex"></span>
    </div>
  </mat-toolbar>
  <app-facility-utilisation-detail
    class="flex"
    [mexusContext]="ctx"
  ></app-facility-utilisation-detail>
</div>
